/**
 * apiConfig.js — Single source of truth for the backend API base URL.
 *
 * Development  : set REACT_APP_API_URL in .env.local → http://localhost:8000
 * Production   : set REACT_APP_API_URL to your server URL (e.g. https://yourdomain.com)
 *                If left empty the app falls back to a relative path so it works
 *                when the React build is served by the FastAPI backend on the same host.
 */
const API_BASE =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:8000"
    : `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? `:${window.location.port}` : ""
      }`);

/**
 * Session-token auto-attach: every fetch() aimed at API_BASE gets an
 * Authorization: Bearer <token> header added automatically, and a 401
 * response clears the stale session and bounces to the login screen.
 * This lets every existing fetch() call site stay untouched while the
 * backend now verifies the caller on every protected endpoint
 * (see services/auth_service.py).
 */
if (!window.__sixersFetchPatched) {
  window.__sixersFetchPatched = true;
  const nativeFetch = window.fetch.bind(window);

  window.fetch = (input, init = {}) => {
    const url = typeof input === "string" ? input : input?.url || "";
    if (url.startsWith(API_BASE)) {
      let token = null;
      try {
        const raw = localStorage.getItem("sixers_user");
        token = raw ? JSON.parse(raw)?.session_token : null;
      } catch { /* malformed storage — proceed without a token */ }

      if (token) {
        init = {
          ...init,
          headers: { ...(init.headers || {}), Authorization: `Bearer ${token}` },
        };
      }
    }

    return nativeFetch(input, init).then((res) => {
      if (res.status === 401 && url.startsWith(API_BASE) && !url.includes("/auth/login") && !url.includes("-auth/login")) {
        try { localStorage.removeItem("sixers_user"); } catch { /* ignore */ }
        if (!window.location.pathname.startsWith("/register")) {
          window.location.reload();
        }
      }
      return res;
    });
  };
}

export default API_BASE;
